import { UmbracoNode } from "../models/UmbracoNode"
import { parseFloatingDate } from "../Helpers/utils";
import { format } from 'date-fns';

export type UpcomingEventItemsModel = {
  nodes: UmbracoNode[] | null
}

export default function UpcomingEventItems({ nodes }: UpcomingEventItemsModel) {
  return (
    <>
      <ul className="block-list">
        <>
        { (nodes && nodes.length > 0) && nodes.map((node, index) => {
            // format() throws on an Invalid Date, which would take the whole
            // sidebar down, so guard on a missing or unparsable value.
            const startDate = parseFloatingDate(node.properties["dateStart"]);
            return (
              <li key={`upcoming-event-item-${index}`}>
                <a href={node.url}>{node.name}{startDate && <> - <span>{format(startDate, 'MMM d')}</span></>}</a>
              </li>
            )
          })
        }
        </>
      </ul>
    </>
  )
} 